import React from 'react';
import { useTranslation } from 'react-i18next';

// Loading indicator shown during translation
const TranslationLoading = ({ size = 'normal', transparent = false }) => {
  const { t } = useTranslation();
  
  return (
    <div className={`flex items-center justify-center ${
      transparent ? 'bg-transparent' : 'bg-black bg-opacity-5'
    } ${
      size === 'small' ? 'p-1' : 'p-3'
    } rounded-lg`}>
      <div className="flex items-center space-x-2">
        <svg 
          className={`animate-spin ${size === 'small' ? 'w-3 h-3' : 'w-5 h-5'} text-gray-600`}
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24"
        >
          <circle 
            className="opacity-25" 
            cx="12" 
            cy="12" 
            r="10" 
            stroke="currentColor" 
            strokeWidth="4"
          ></circle>
          <path 
            className="opacity-75" 
            fill="currentColor" 
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        {size !== 'small' && (
          <span className="text-sm font-medium text-gray-700">
            {t('translating', 'Translating...')}
          </span>
        )}
      </div>
    </div>
  );
};

export default TranslationLoading;
